'use client';

import { Typography, theme, IcChevronRight } from '@bgzt/ui';
import { LinkByEnvironment } from '~/components';
import { PROMOTION_2025_08_09 } from '~/app/_constants/promotion';

import styles from './PromotionBanner.module.css';

type Props = {
  price: number;
};

// 상수 정의
const PRICE_THRESHOLDS = {
  MINIMUM: 50_000,
  FIRST_PURCHASE_MAX: 300_000,
  DISCOUNT_10M: 1_000_000,
  DISCOUNT_5M: 500_000,
  DISCOUNT_3M: 300_000,
  DISCOUNT_1M: 100_000,
} as const;

const DISCOUNT_CONFIGS = [
  { threshold: PRICE_THRESHOLDS.DISCOUNT_10M, amount: '10만 원', type: 'immediate' },
  { threshold: PRICE_THRESHOLDS.DISCOUNT_5M, amount: '5만 원', type: 'immediate' },
  { threshold: PRICE_THRESHOLDS.DISCOUNT_3M, amount: '3만 원', type: 'immediate' },
  { threshold: PRICE_THRESHOLDS.DISCOUNT_1M, amount: '1만 원', type: 'first_purchase' },
  { threshold: PRICE_THRESHOLDS.MINIMUM, amount: '5천 원', type: 'first_purchase' },
] as const;

export const PromotionBanner = ({ price }: Props) => {
  if (price < PRICE_THRESHOLDS.MINIMUM) return null;

  return (
    <LinkByEnvironment href={PROMOTION_2025_08_09.EXHIBITION_URL} target="_blank">
      <div className={styles.container}>
        {renderBannerText(price)}

        <IcChevronRight fill={theme.colors['gray-500']} size={10} />
      </div>
    </LinkByEnvironment>
  );
};

const getDiscountConfig = (price: number) => {
  return DISCOUNT_CONFIGS.find((config) => price >= config.threshold);
};

const renderBannerText = (price: number) => {
  const config = getDiscountConfig(price);
  if (!config) return null;

  const { amount, type } = config;

  if (type === 'immediate') {
    return (
      <Typography variant="L9" color={'#008DFA'}>
        {amount} 즉시 할인
        <Typography variant="L10" color={'gray-900'}>
          받고 구매하기
        </Typography>
      </Typography>
    );
  }

  return (
    <>
      <Typography variant="L10" color={'gray-900'}>
        첫 구매라면 무조건
      </Typography>
      <Typography variant="L9" color={'#008DFA'}>
        {amount} 할인받기
      </Typography>
    </>
  );
};
